<template lang="html">
  <header id="header" v-if="$route.name != 'preHomePage'">
    <div class="header-content">

      <section class="top-section">
        <div class="container med-container">
          <div class="row">
            <!-- <div class="col-lg col-form">
              <b-form @submit="onSubmit">
                <b-form-input
                  v-model="form.keywords"
                  type="text"
                  placeholder="SEARCH IN OUR KNOWLEDGE CENTER..."
                  size="sm"
                  required
                ></b-form-input>
                <b-button type="submit" size="sm"><i class="fas fa-search"></i></b-button>
              </b-form>
            </div> -->

            <div class="col-lg col-buttons">
              <!-- <span class="d-none d-sm-inline-block mr-4"><i class="fa-light fa-envelope"></i> Email: <a href="mailto:info@quinceanerashopping.com">contacto@dominio.com</a></span> -->
              <span class="d-none d-sm-inline-block"><i class="fa-brands fa-whatsapp"></i> WhatsApp: <a target="_blank" :href="'https://wa.me/'+$root.onlyNumbers($root.contactInfo.whatsapp)">{{ $root.contactInfo.whatsapp }}</a></span>
              <!-- <a class="d-none d-sm-inline-block whatsapp ml-4" target="_blank" href="https://wa.me/3320660745"><i class="icon"></i> ATENCIÓN AL CLIENTE</a> -->
              <!-- <router-link class="d-none d-sm-inline-block" to="/cart"><i class="fa-solid fa-cart-shopping"></i> CARRITO</router-link> -->
              <a class="ml-lg-4 t-150 btn-special d-none d-lg-inline" download target="_blank" href="public/files/PRESENTACION_FEROS.pdf"><i class="fa-regular fa-file-pdf icon"></i> DESCARGAR PRESENTACIÓN</a>
            </div>

            <!-- <div class="col-lg col-social-networks">
              <a class="btn-network" href="#"><i class="fab fa-google-play"></i></a>
              <a class="btn-network" href="#"><i class="fab fa-apple"></i></a>
            </div> -->
          </div>
        </div>
      </section>

      <section class="menu-section">
        <b-navbar toggleable="lg" type="dark" variant="info">
          <div class="container med-container">
            <b-navbar-brand to="/home">
              <img src="public/images/logo.png" alt="XV Shopping">
            </b-navbar-brand>

            <b-navbar-toggle target="nav-collapse">
              <i class="fa-sharp fa-regular fa-bars"></i>
            </b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
              <b-navbar-nav class="ml-auto">
                <b-nav-item class="simple-item" to="/">Inicio</b-nav-item>
                <!-- <li class="nav-item item-simple">
                  <a class="nav-link" @click="isHActive = !isHActive">Catálogo <i class="fas fa-chevron-down submenu-icon"></i></a>
                </li> -->
                <!-- <b-nav-item-dropdown right>
                  <template #button-content>
                    <span>Productos</span>
                  </template>
                  <b-dropdown-item to="">Producto 1</b-dropdown-item>
                  <b-dropdown-item to="">Producto 2</b-dropdown-item>
                </b-nav-item-dropdown> -->
                <b-nav-item class="simple-item" to="/productos">Productos</b-nav-item>
                <b-nav-item class="simple-item" to="/empresa">Empresa</b-nav-item>
                <b-nav-item class="simple-item" to="/beneficios">Beneficios</b-nav-item>
                <b-nav-item class="simple-item" to="/blog">Blog</b-nav-item>
                <b-nav-item class="simple-item" to="/contacto">Contacto</b-nav-item>

                <!-- <b-nav-item class="icon-item" to="/contacto">
                  <i class="fas fa-envelope icon"></i> <span class="d-lg-none">Contacto</span>
                </b-nav-item> -->

                <b-nav-item class="icon-item special d-lg-none" target="_blank" href="public/files/PRESENTACION_FEROS.pdf">
                  <i class="fa-regular fa-file-pdf icon"></i> <span class="d-lg-none">Descargar presentación</span>
                </b-nav-item>

                <b-nav-item class="icon-item" to="/cart">
                  <i class="fa-solid fa-cart-shopping icon"></i> <span class="d-lg-none">Carrito</span>
                </b-nav-item>

                <b-nav-item-dropdown class="icon-item" right v-if="$root.logged == false">
                  <template #button-content>
                    <span>
                      <i class="fas fa-user-circle icon"></i> <span class="d-lg-none">Mi cuenta</span>
                  </span>
                  </template>
                  <b-dropdown-item to="/login" >Iniciar sesión</b-dropdown-item>
                  <b-dropdown-item to="/afiliate">Registrarse</b-dropdown-item>
                </b-nav-item-dropdown>
                <b-nav-item class="icon-item" to="/usuario" v-else>
                  <i class="fas fa-user-circle"></i> Mi cuenta
                </b-nav-item>

              </b-navbar-nav>
            </b-collapse>
          </div>
        </b-navbar>
      </section>

      <section class="bottom-section">
        <div class="container med-container">
          <div class="row">
            <div class="col-lg-7 col-form">

              <b-nav-form class="search-form" @submit="onSubmitSearch">
                <label for="i-keywords">Buscar productos:</label>

                <div class="form-results-containter">
                  <b-form-input placeholder="" v-model="formSearch.keywords"></b-form-input>

                  <!-- <b-form-select v-model="formSearch.category" >
                    <b-form-select-option :value="null">Categorías</b-form-select-option>
                    <b-form-select-option v-for="(cat,indx) in categories" :key="indx" :value="cat.id">{{cat.name}}</b-form-select-option>
                  </b-form-select> -->

                  <b-button class="btn-search" type="submit"><span class="d-none d-sm-inline">Buscar</span><i class="fas fa-search d-sm-none"></i></b-button>

                  <!-- Autocomplete -->
                  <div class="bg-autocomplete" v-bind:class="{ active: isAutocompActive }" @click="isAutocompActive = false;"></div>
                  <div class="box-autocomplete" v-bind:class="{ active: isAutocompActive }">
                    <div class="box">
                      <div class="box-results">

                        <div class="d-block text-center">
                          <!-- <loading2 v-if="isAuComLoading"></loading2> -->
                        </div>

                         <router-link class="flex-center-xy row-product"
                          :to="'/producto/'+$root._converToURL(p.name, p.id)"
                          v-for="(p, rInx) in autocompProds"
                          v-if="autocompProds.length > 0"
                          :key="'rInx-'+rInx">
                          <div class="col img" v-bind:style="{ backgroundImage: 'url('+p.imageUrl+')' }"></div>
                          <div class="col txt">
                            <h6 class="name">{{ p.name }}</h6>
                          </div>
                        </router-link>

                        <router-link class="flex-center-xy trans-150 row-product all t-150" v-if="autocompProds.length > 0" :to="{ path: '/busqueda', query: {keywords:this.formSearch.keywords} }">
                          <div class="col txt text-center">Mostrar todos</div>
                        </router-link>

                        <a class="flex-center-xy row-product no-shad" v-if="autocompProds.length <= 0 && !isAuComLoading">
                          <div class="col txt text-center">Sin resultados</div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <!--  -->
                </div>
              </b-nav-form>
            </div>

            <div class="col-lg-5 col-text">
              <!-- <a class="link-pdf"><i class="icon"></i> KITS</a> -->
              <!-- <a class="ml-3 link"><i class="fa-solid fa-file-signature"></i> AFÍLIATE</a> -->
              <a class="btn-link st-1 t-150 mr-2" @click="toKits()"><i class="fa-solid fa-briefcase icon-txt"></i> KITS</a>
              <!-- <a class="btn-link st-2 t-150" @click="$refs['modal-form'].show();"><i class="fa-solid fa-file-signature icon-txt"></i> AFÍLIATE</a> -->
              <router-link class="btn-link st-2 t-150" to="/afiliate"><i class="fa-solid fa-file-signature icon-txt"></i> AFÍLIATE</router-link>
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- Modal Formulario -->
    <b-modal modal-class="modal-info-s1" ref="modal-form" size="lg" title="" centered hide-footer no-close-on-backdrop no-close-on-esc>
      <div class="row no-gutters">
        <div class="col-12 col-info">
          <h2 class="mb-3 text-center modal-title" style="letter-spacing: 4px;">¡AFÍLIATE!</h2>

          <b-form @submit="onSubmitForm">
            <div class="row">
              <div class="col-12 text-center text-sm-right mb-2 mb-lg-0 ml-auto">
                <h6 class="d-block d-sm-inline-block"><strong>FECHA:</strong> 10/12/2025</h6>
                <span class="d-none d-sm-inline-block mx-2">|</span>
                <h6 class="d-block d-sm-inline-block"><strong>AFILIADO NO:</strong> 56506</h6>
              </div>

              <div class="col-12 col-i">
                <h6 class="subtitle">SOLICITANTE</h6>
                <hr class="sep" />
              </div>

              <div class="col-lg-4 col-i">
                <b-form-group class="custom-form-group-s2" label="APELLIDO PATERNO*">
                  <b-form-input
                    v-model="joinForm.apellidoPaterno"
                    type="text"
                    placeholder=""
                    required
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-lg-4 col-i">
                <b-form-group class="custom-form-group-s2" label="APELLIDO MATERNO*">
                  <b-form-input
                    v-model="joinForm.apellidoMaterno"
                    type="text"
                    placeholder=""
                    required
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-lg-4 col-i">
                <b-form-group class="custom-form-group-s2" label="NOMBRE*">
                  <b-form-input
                    v-model="joinForm.nombre"
                    type="text"
                    placeholder=""
                    required
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-lg-4 col-i">
                <b-form-group class="custom-form-group-s2" label="RFC*">
                  <b-form-input
                    v-model="joinForm.rfc"
                    type="text"
                    placeholder=""
                    required
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-lg-4 col-i">
                <b-form-group class="custom-form-group-s2" label="TELÉFONO*">
                  <b-form-input
                    v-model="joinForm.phone"
                    type="text"
                    placeholder=""
                    minwidth="10"
                    maxwidth="10"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-lg-4 col-i">
                <b-form-group class="custom-form-group-s2" label="CELULAR*">
                  <b-form-input
                    v-model="joinForm.celular"
                    type="text"
                    placeholder=""
                    minwidth="10"
                    maxwidth="10"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-lg-5 col-i">
                <b-form-group class="custom-form-group-s2" label="CORREO ELECTRÓNICO*">
                  <b-form-input
                    v-model="joinForm.email"
                    type="email"
                    placeholder=""
                    required
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-lg-7"></div>

              <div class="col-12 col-i pt-3">
                <h6 class="subtitle">DOMICILIO</h6>
                <hr class="sep" />
              </div>

              <div class="col-lg-5 col-i">
                <b-form-group class="custom-form-group-s2" label="CALLE Y NÚMERO*">
                  <b-form-input
                    v-model="joinForm.calle"
                    type="text"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-lg-5 col-i">
                <b-form-group class="custom-form-group-s2" label="COLONIA*">
                  <b-form-input
                    v-model="joinForm.colonia"
                    type="text"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-6 col-lg-2 col-i">
                <b-form-group class="custom-form-group-s2" label="C.P.*">
                  <b-form-input
                    v-model="joinForm.cp"
                    type="number"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-lg-5 col-i">
                <b-form-group class="custom-form-group-s2" label="ESTADO">
                  <b-form-select v-model="joinForm.state" required>
                    <b-form-select-option :value="null">SELECCIONE UNA OPCIÓN</b-form-select-option>
                    <b-form-select-option value="1">JALISCO</b-form-select-option>
                    <b-form-select-option value="2">ZACATECAS</b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </div>

              <div class="col-lg-5 col-i">
                <b-form-group class="custom-form-group-s2" label="ALCALDÍA O MUNICIPIO">
                  <b-form-select v-model="joinForm.city" required>
                    <b-form-select-option :value="null">SELECCIONE UNA OPCIÓN</b-form-select-option>
                    <b-form-select-option value="1">GUADALAJARA</b-form-select-option>
                    <b-form-select-option value="2">ZAPOPAN</b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </div>

              <div class="col-12 pt-3"></div>
              <div class="col-lg-6 col-i">
                <b-form-group class="custom-form-group-s2" label="BENEFICIARIO HEREDERO*">
                  <b-form-input
                    v-model="joinForm.beneficiario"
                    type="text"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-lg-4 col-i">
                <b-form-group class="custom-form-group-s2" label="PARENTESCO*">
                  <b-form-input
                    v-model="joinForm.parentesco"
                    type="text"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-lg-4 col-i">
                <b-form-group class="custom-form-group-s2" label="DEPOSITAR A BANCO*">
                  <b-form-input
                    v-model="joinForm.banco"
                    type="text"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-lg-4 col-i">
                <b-form-group class="custom-form-group-s2" label="CUENTA*">
                  <b-form-input
                    v-model="joinForm.bancoCuenta"
                    type="text"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-lg-6 col-i">
                <b-form-group class="custom-form-group-s2 mb-0" label="INE*"></b-form-group>
                <b-form-file plain v-model="joinForm.ine"></b-form-file>
              </div>

              <div class="col-lg-6 col-i">
                <b-form-group class="custom-form-group-s2 mb-0" label="CONSTANCIA DE SITUACIÓN FISCAL*"></b-form-group>
                <b-form-file plain v-model="joinForm.constancia"></b-form-file>
              </div>

              <div class="col-12 col-i pt-4 mt-1">
                <h6 class="subtitle">INVITADO POR</h6>
                <hr class="sep" />
              </div>

              <div class="col-lg-4 col-i">
                <b-form-group class="custom-form-group-s2" label="APELLIDO PATERNO*">
                  <b-form-input
                    v-model="joinForm.invApellidoPaterno"
                    type="text"
                    placeholder=""
                    required
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-lg-4 col-i">
                <b-form-group class="custom-form-group-s2" label="APELLIDO MATERNO*">
                  <b-form-input
                    v-model="joinForm.invApellidoMaterno"
                    type="text"
                    placeholder=""
                    required
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-lg-4 col-i">
                <b-form-group class="custom-form-group-s2" label="NOMBRE*">
                  <b-form-input
                    v-model="joinForm.invitadoNombre"
                    type="text"
                    placeholder=""
                    required
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-6 col-lg-3 col-i">
                <b-form-group class="custom-form-group-s2" label="NO. AFILIADO*">
                  <b-form-input
                    v-model="joinForm.invitadoNumero"
                    type="number"
                    placeholder=""
                    required
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-12 col-i pb-1 pt-2">
                <h6 class="subtitle-2">COLOCAR DEBAJO DE</h6>
              </div>

              <div class="col-lg-4 col-i">
                <b-form-group class="custom-form-group-s2" label="APELLIDO PATERNO*">
                  <b-form-input
                    v-model="joinForm.invApellidoPaterno"
                    type="text"
                    placeholder=""
                    required
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-lg-4 col-i">
                <b-form-group class="custom-form-group-s2" label="APELLIDO MATERNO*">
                  <b-form-input
                    v-model="joinForm.invApellidoMaterno"
                    type="text"
                    placeholder=""
                    required
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-lg-4 col-i">
                <b-form-group class="custom-form-group-s2" label="NOMBRE*">
                  <b-form-input
                    v-model="joinForm.invitadoNombre"
                    type="text"
                    placeholder=""
                    required
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-6 col-lg-3 col-i">
                <b-form-group class="custom-form-group-s2" label="NO. AFILIADO*">
                  <b-form-input
                    v-model="joinForm.invitadoNumero"
                    type="number"
                    placeholder=""
                    required
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>

            <p class="text-right">
              <b-button type="submit" class="btn btn-s1 btn-lg outline-c-white-2 px-5">AFILIARME</b-button>
            </p>
          </b-form>
        </div>
      </div>
    </b-modal>
    <!--  -->

    <!-- Productos -->
    <div class="t-250 products-menu" v-bind:class="{ active: isHActive }">
      <div class="menu-bg" @click="isHActive = false"></div>

      <div class="tablist" role="tablist">
        <div class="t-250 box-title" @click="isHActive = false">
          <h4>CATÁLOGO</h4>
          <!-- <br>
          <h5 v-on:click="$router.push('/categoria');">Categorias</h5> -->
          <!-- <i class="fas fa-chevron-left icon"></i> -->
          <i class="fas fa-chevron-square-left icon"></i>
        </div>

        <b-card no-body class="mb-1" v-for="(category, pcatIndex) in categories" :key="pcatIndex">
          <b-card-header header-tag="header" role="tab">
            <div v-if="category.subcategories" class="btn-toggle">
              <router-link :to="'/categoria/'+$root._converToURL(category.name, category.id)">{{ category.name }}</router-link>
              <span class="fake-toggle" v-b-toggle="'accordion-'+pcatIndex"></span>
            </div>
            <router-link v-else class="btn-toggle" :to="'/productos/'+$root._converToURL(category.name, category.id)">{{ category.name }}</router-link>
          </b-card-header>

          <b-collapse v-if="category.subcategories" :id="'accordion-'+pcatIndex" visible accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <ul class="ul-sub-options">
                <li v-for="subcategory in category.subcategories">
                  <router-link class="t-250" :to="'/subcategoria/'+$root._converToURL(subcategory.name, subcategory.id)">{{ subcategory.name }}</router-link>
                </li>
              </ul>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
     
    </div>
    <!--  -->
     <loader v-if="$root.isLoading == true" object="#bb2622" color1="#000000" color2="#21801e" size="5" speed="2" bg="#343a40" objectbg="#999793" opacity="80" disableScrolling="false" name="circular"></loader>
      <sweet-modal ref="modalAlert" :icon="$root.modaldata.icon" >
            <p v-html="$root.modaldata.msg"></p>
      </sweet-modal>
  </header>
</template>

<script>
export default {
  data() {
    return {
      isAutocompActive: false,
      isAuComLoading: true,
      autocompProds: [
        { id: 1, img: 'public/images/pages/products/product-3.jpg', brand: "Feros", price: "108.00", name: 'Erulux' },
        { id: 2, img: 'public/images/pages/products/product-2.jpg', brand: "Feros", price: "90.00", name: 'Cuña' },
        { id: 3, img: 'public/images/pages/products/product-1.jpg', brand: "Feros", price: "75.00", name: 'Polvorin' },
      ],

      // == Products menu ==
      isHActive: false,
      categories:[ // ** Remover el contenido de este array ejemplo al conectar para no dejar CODIGO BASURA
        // { id: 2, name: 'Ejemplo de categoría', subcategories: [
        //   { id: 1, name: 'Ejemplo de subcategoría' },
        //   { id: 2, name: 'Ejemplo de subcategoría' },
        // ] },
        // { id: 4, name: 'Ejemplo de categoría', subcategories: [
        //   { id: 1, name: 'Ejemplo de subcategoría' },
        //   { id: 2, name: 'Ejemplo de subcategoría' },
        // ]},
        { id: 1, name: 'Accesorios' },
        { id: 2, name: 'Baby Shower' },
        { id: 3, name: 'Bautizo' },
        { id: 4, name: 'Boda' },
        { id: 5, name: 'Broches' },
        { id: 6, name: 'Cadete' },
        { id: 7, name: 'Comunion' },
        { id: 8, name: 'Confirmacion' },
        { id: 9, name: 'Fiestas' },
        { id: 1, name: 'Fiestas Mexicanas' },
        { id: 2, name: 'Graduacion' },
        { id: 3, name: 'Imagenes Religiosas' },
        { id: 4, name: 'Presentacion' },
        { id: 5, name: 'Quinceañera' },
        { id: 3, name: 'Religioso' },
        { id: 7, name: 'Rosarios' },
      ],
      // == ==

      joinForm: {
        name: null,
      },

      formSearch: {
        keywords: null,
        category: null,
      }
    }
  },

  methods: {
    onSubmitSearch(event) {
      event.preventDefault();

      this.$router.push({ path: '/busqueda', query: {keywords:this.formSearch.keywords }});

      setTimeout(()=> this.formSearch.keywords = null, 150)

    },

    onSubmitForm(event) {
      event.preventDefault();
      alert('Gracias por afiliarte');

      this.$refs['modal-form'].hide();
    },
    toKits() {
      this.$router.push({ path: '/busqueda', query: {keywords:'KITS' }});
    }
  },

  watch: {
    $route (to, from){
      // Ocultar menu cada vez que cambie la ruta
      this.isAutocompActive = false;
      // this.autocompProds = [];

      // Ocultar menu cada vez que cambie la ruta
      this.isHActive = false;
    },

    'formSearch.keywords' (val, oldVal){
        this.isAutocompActive = false;
        this.autocompProds = [];
        if(val.length >= 3){ // Buscar solo si tiene al menos 3 letras
       
            axios.post(tools.url('/api/productsAutocomplete'),{keywords:this.formSearch.keywords}).then((response)=>{
              this.autocompProds = response.data;
            }).catch((error)=>{
              
            });
   
            this.isAutocompActive = true;
        } else {
          this.isAutocompActive = false;
        }
    },
    '$root.modaldata.show':function(val){
        if(val == true){
          this.$refs.modalAlert.open();
        }
    }
  },

  mounted() {
    this.$refs.modalAlert.$on('close', () => {
      this.$root.modaldata.show = false;
    });
  }
}
</script>
